
import XDateCalendar from "../extra/XDateCalendar";

import { Box, Typography } from '@mui/material';
import { BsEnvelope, BsXLg } from "react-icons/bs";
import { BsArrowLeftRight, BsPrinter, BsCloudArrowDown, BsCardChecklist } from "react-icons/bs";
// UI

import {
    ChevronDownIcon, ChevronUpIcon, ChevronRightIcon,
    ChevronLeftIcon, CameraControlIcon, Calendar24, ZoomInIcon, ZoomOutIcon, ChevronBackwardIcon, ChevronForwadIcon,
    NormalViewIcon, SplitViewIcon, CompareViewIcon, OverlayViewIcon, SpotCompareViewIcon, MagnifyViewIcon, LocationIcon,
    EmailIcon, ScheduleEmailIcon, DownloadImageIcon, TimeImageIcon, PrintIcon, ReportIcon, ProcoreIcon, AutodeskIcon
} from "./icons/Icons";

const dateBarStyle = { display: 'flex', justifyContent: 'space-between', background: '#e3e3e3ff', p: 1, fontSize: 14 }

const naviIcons = {
    prev: <ChevronLeftIcon />,
    next: <ChevronRightIcon />,
    move_prev: <ChevronLeftIcon />,
    move_next: <ChevronRightIcon />,
    move_up: <ChevronUpIcon />,
    move_down: <ChevronDownIcon />,
    center: <CameraControlIcon />,
    zoom_in: <ZoomInIcon />,
    zoom_out: <ZoomOutIcon />,
    backward: <ChevronBackwardIcon />,
    forward: <ChevronForwadIcon />,
}

const mailIcons = [
    <Typography className="hover" textAlign={'center'} fontSize={12}><Box><BsEnvelope fontSize={16} /></Box>Email</Typography>,
    <Typography className="hover" textAlign={'center'} fontSize={12}><Box ><BsEnvelope fontSize={16} /></Box>Schedule Email</Typography>,
    <Typography className="hover" closable={"true"} textAlign={'center'} fontSize={12}><a className="hover" download={"Download"}> <Box><BsCloudArrowDown fontSize={16} /></Box>Download Image</a></Typography>,
    <Typography className="hover" closable={"true"} textAlign={'center'} fontSize={12}><a className="hover" download={"Download"}><Box><BsCloudArrowDown fontSize={16} /></Box>Image <br />with timestamp</a></Typography>,
    <Typography className="hover" closable={"true"} textAlign={'center'} fontSize={12}><Box closable={"true"}><BsPrinter fontSize={16} /></Box>Print</Typography>,
    <Typography className="hover" closable={"true"} textAlign={'center'} fontSize={12}><Box closable={"true"}><BsCardChecklist fontSize={16} /></Box>Report</Typography>,
    <Typography onClick={() => { }} className="hover" closable={"true"} textAlign={'center'} fontSize={12}><Box closable={"true"}><BsArrowLeftRight /></Box>Procore</Typography>,
    <Typography onClick={() => { }} className="hover" closable={"true"} textAlign={'center'} fontSize={12}><Box closable={"true"}><BsArrowLeftRight /></Box>Autodesk</Typography>,
]

const viewsIcon = [["Normal View", 0, <NormalViewIcon fontSize={16} />],
["Split View", 1, <SplitViewIcon fontSize={16} />],
["Compare View", 2, <CompareViewIcon fontSize={16} />],
["Overlay", 3, <OverlayViewIcon fontSize={16} />],
["Spot Compare", 4, <SpotCompareViewIcon fontSize={16} />],
["Magnify", 5, <MagnifyViewIcon fontSize={16} />],
["Location", 6, <LocationIcon fontSize={16} />],
]

const shareIcon = [
    ["Email", 7, <EmailIcon fontSize={16} />],
    ["Schedule Email", 8, <ScheduleEmailIcon fontSize={16} />],
    ["Download", 9, <DownloadImageIcon fontSize={16} />],
    ["Print", 11, <PrintIcon fontSize={16} />],
    ["Image with <br/> timestamp", 10, <TimeImageIcon fontSize={16} />],
    ["Report", 12, <ReportIcon fontSize={16} />],
    ["Procore", 13, <ProcoreIcon fontSize={16} />],
    ["Autodesk", 14, <AutodeskIcon fontSize={16} />],
]

const DropDown = ({ customIcon = null, icon = "icon", text = "", right = false, open = false, children, }) => {
    const letfRightShift = !right ? { left: -16, right: 'auto' } : { left: 'auto', right: 10 }
    return <Box className="over-menu">
        {!customIcon && <Box display={'flex'} alignItems={'center'} gap={1} className="open-menu">
            {!right && <><Box className="tool-menu">{icon}</Box> <Box>{text}</Box></>}
            {right && <> <Box>{text}</Box><Box className="tool-menu tool-submenu">{icon}</Box></>}
        </Box>}
        {customIcon && <>{customIcon}</>}
        <Box className={open ? 'hover-box1' : `hover-box`} sx={{
            ...letfRightShift,
            position: 'absolute',
            display: 'inline-flex',
            minWidth: 325,
        }}>
            <Box className={`hover-content ${right ? 'right-content' : ''}`}>
                {children}
            </Box>
        </Box>
    </Box>
}
const DateBar = ({
    monthOnly = false,
    imageData, showImage1, setShowImage1 = () => { },
    imageData2, showImage2, setShowImage2 = () => { },
    onDateChange = () => { }, formatCurrentImage = () => { },
    onMonthChange = () => { },
    onClose = () => { } }) => {
    if (monthOnly) {
        return <Box sx={dateBarStyle}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <DropDown icon={<Calendar24 />} text={showImage1?.fd}>
                    <XDateCalendar
                        mode={{ views: ["year", "month"] }}
                        key={imageData?.root}
                        imageData={imageData}
                        onDateChange={(date) => {
                            let [year, month] = date.split("-")
                            onMonthChange(month, year)
                        }}
                    // onAction={(action, value) => {
                    //     if (action == "date") {

                    //         let formattedData = formatCurrentImage(imageData, value?.utc)
                    //         setShowImage1({
                    //             path: formattedData?.currentImage + "?t=" + new Date().getTime(),
                    //             fd: formattedData?.formattedDate
                    //         })
                    //     }
                    //     if (action == "timeline") {
                    //         // setShowTimeline(true)
                    //     }
                    //     if (action == "most-recent") {
                    //         // onDateChange(undefined, 3)
                    //     }
                    // }}
                    />
                </DropDown>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <BsXLg title='Close' onClick={onClose} style={{ color: '#ffd80c', fontSize: 20, fontWeight: 900 }} />
            </Box>
        </Box>
    }
    return <Box sx={dateBarStyle}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <DropDown icon={<Calendar24 />} text={showImage1?.fd}>
                <XDateCalendar
                    key={imageData?.root}
                    imageData={imageData}
                    onDateChange={(date) => {
                        onDateChange(date, 1)
                    }}
                    onAction={(action, value) => {
                        if (action == "date") {

                            let formattedData = formatCurrentImage(imageData, value?.utc)
                            setShowImage1({
                                path: formattedData?.currentImage + "?t=" + new Date().getTime(),
                                fd: formattedData?.formattedDate
                            })
                        }
                        if (action == "timeline") {
                            // setShowTimeline(true)
                        }
                        if (action == "most-recent") {
                            // onDateChange(undefined, 3)
                        }
                    }}
                />
            </DropDown>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <BsXLg title='Close' onClick={onClose} style={{ color: '#ffd80c', fontSize: 20, fontWeight: 900 }} />
            <DropDown icon={<Calendar24 />} text={showImage2?.fd} right={true}>
                <XDateCalendar
                    key={imageData2?.root}
                    imageData={imageData2}
                    onDateChange={(date) => {
                        onDateChange(date, 2)
                    }}
                    onAction={(action, value) => {
                        if (action == "date" && imageData2) {
                            let formattedData = formatCurrentImage(imageData2, value?.utc)
                            setShowImage2({
                                path: formattedData?.currentImage + "?t=" + new Date().getTime(),
                                fd: formattedData?.formattedDate
                            })
                        }
                        if (action == "timeline") {
                            // setShowTimeline(true)
                        }
                        if (action == "most-recent") {
                            // onDateChange(undefined, 3)
                        }
                    }}
                />
            </DropDown>
        </Box>
    </Box>
}

const formatLatLng = (datas, key, nameKey) => {
    // Helper: clean the camera_location string and split into [lat, lng]
    function rel(d, key) {
        const parts = d[key]?.replace(/[^\d.,-]/g, '')?.split(',');
        return parts?.map(Number); // Convert strings to numbers
    }
    // Create objects like { latlng: [lat, lng], desc: 'camera name' }
    let ds = datas.map((d) => ({

        latlng: rel(d, key),
        desc: d[nameKey],
        thumbnail: d.thumbnail
    }));
    // Filter: only keep those with valid lat/lng numbers
    return ds.filter(
        (d) =>
            d.latlng &&
            d.latlng.length === 2 &&
            !isNaN(d.latlng[0]) &&
            !isNaN(d.latlng[1])
    );
};

async function printImage(
    baseUrl,
    overlayUrl,
    text = "Sample Text",
    title = ""
) {
    const baseImg = new Image();
    const overlayImg = new Image();

    baseImg.crossOrigin = "anonymous";
    overlayImg.crossOrigin = "anonymous";

    baseImg.src = baseUrl;
    overlayImg.src = overlayUrl;

    await Promise.all([
        new Promise(res => (baseImg.onload = res)),
        new Promise(res => (overlayImg.onload = res))
    ]);

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = baseImg.width;
    canvas.height = baseImg.height;

    // 1️⃣ Draw base image
    ctx.drawImage(baseImg, 0, 0);

    // 2️⃣ Draw overlay (bottom-right)
    const overlayWidth = baseImg.width * 0.2;
    const overlayHeight = overlayImg.height * (overlayWidth / overlayImg.width);

    ctx.drawImage(
        overlayImg,
        canvas.width - overlayWidth - 10,
        canvas.height - overlayHeight - 10,
        overlayWidth,
        overlayHeight
    );

    // 3️⃣ Draw text (right side)
    const padding = 20;
    ctx.font = "bold 30px Arial";
    ctx.textAlign = "right";

    const textWidth = ctx.measureText(text).width;

    // background
    ctx.fillStyle = "rgba(0,0,0,0.5)";
    ctx.fillRect(
        canvas.width - textWidth - padding - 10,
        padding,
        textWidth + 10,
        40
    );

    // text
    ctx.fillStyle = "white";
    ctx.fillText(text, canvas.width - padding, padding + 30);

    // 4️⃣ Convert canvas to image
    const finalImage = canvas.toDataURL("image/png");

    // 5️⃣ Open print window
    const win = window.open('', '_blank');

    win.document.write(`
        <html>
            <head>
                <title>${title}</title>
                <style>
                    body {
                        margin: 0;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        height: 100vh;
                    }
                    img {
                        max-width: 100%;
                        max-height: 100%;
                    }
                </style>
            </head>
            <body>
                <img src="${finalImage}" 
                     onload="window.print(); window.close();" />
            </body>
        </html>
    `);

    win.document.close();
}
async function downloadImage(
    baseUrl,
    overlayUrl,
    text = "Sample Text",
    fileName = "image.png"
) {
    const baseImg = new Image();
    const overlayImg = new Image();

    baseImg.crossOrigin = "anonymous";
    overlayImg.crossOrigin = "anonymous";

    baseImg.src = baseUrl;
    overlayImg.src = overlayUrl;

    await Promise.all([
        new Promise(res => (baseImg.onload = res)),
        new Promise(res => (overlayImg.onload = res))
    ]);

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = baseImg.width;
    canvas.height = baseImg.height;

    // 1️⃣ Draw base image
    ctx.drawImage(baseImg, 0, 0);

    // 2️⃣ Draw overlay (bottom-right)
    const overlayWidth = baseImg.width * 0.2;
    const overlayHeight = overlayImg.height * (overlayWidth / overlayImg.width);

    ctx.drawImage(
        overlayImg,
        canvas.width - overlayWidth - 10,
        canvas.height - overlayHeight - 10,
        overlayWidth,
        overlayHeight
    );

    // 3️⃣ Draw text (RIGHT SIDE)
    ctx.font = "bold 30px Arial";
    ctx.fillStyle = "white";
    ctx.textAlign = "right"; // 👈 important for right alignment

    const padding = 20;

    ctx.fillText(
        text,
        canvas.width - padding,  // right side
        padding + 30             // top position
    );

    // Optional: text background for better visibility
    const textWidth = ctx.measureText(text).width;
    const textHeight = 35;

    ctx.fillStyle = "rgba(0,0,0,0.5)";
    ctx.fillRect(
        canvas.width - textWidth - padding - 10,
        padding,
        textWidth + 10,
        textHeight
    );

    // redraw text on top
    ctx.fillStyle = "white";
    ctx.fillText(text, canvas.width - padding, padding + 30);

    // 4️⃣ Download
    canvas.toBlob((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    });
}

export { viewsIcon, shareIcon, DropDown, DateBar, formatLatLng, naviIcons, mailIcons, printImage, downloadImage }